<template>
	<div class="mx-auto text-center py-24">
		<h2 class="text-2xl font-bold">
			Thank you, Your Order has been created successfully.
		</h2>
		<p>
			<span class="font-bold">Order Reference ID: </span>
			<span>{{ $route.params.id }}</span>
		</p>
	</div>
</template>
<script>
export default {
	name: 'CheckoutSuccess'
}
</script>
